<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Viber:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
          ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>

      <!-- Text Input -->
      <div class="row mb-3">
        <div class="col-12">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'text')"
            [blockData]="block.variables?.text ?? ''"
            [placeholder]="textPlaceHolder"
            [maxLength]="4000"
            variable="text"
          ></app-block-text>
        </div>
      </div>

      <!-- Image URL Input -->
      <div class="row mb-3">
        <div class="col-12">
          <app-block-text
            [type]="'link'"
            (handleOnChange)="onChange($event, 'image_url')"
            [blockData]="block.variables?.image_url ?? ''"
            [placeholder]="imageUrlPlaceHolder"
            [maxLength]="4000"
            [isImage]="true"
            variable="image_url"
          ></app-block-text>
        </div>
      </div>

      <!-- CTA Text Input -->
      <div class="row mb-3">
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'cta_text')"
            [blockData]="block.variables?.cta_text ?? ''"
            [placeholder]="ctaTextPlaceHolder"
            [maxLength]="100"
            variable="cta_text"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            (handleOnChange)="onChange($event, 'cta_link')"
            [blockData]="block.variables?.cta_link ?? ''"
            [placeholder]="ctaLinkPlaceHolder"
            [maxLength]="4000"
            variable="cta_link"
          ></app-block-text>
        </div>
      </div>
    </div>

    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side viber-preview" [class.mobile-preview]="isPreview">
        <!-- Custom Phone Frame (only shown in preview mode) -->
        <div *ngIf="isPreview" class="phone-frame">
          <div class="phone-screen">
            <!-- Status Bar -->
            <div class="status-bar">
              <span class="time">{{ currentTime }}</span>
              <span class="icons">
                <span>📶</span><span>🔋</span>
              </span>
            </div>

            <!-- Viber App Content -->
            <div class="screen-content">
              <!-- Viber Header -->
              <div class="viber-header">
                <span class="back-arrow">‹</span>
                <div class="avatar">V</div>
                <span class="contact-name">Valamar</span>
              </div>

              <!-- Message Bubble -->
              <div class="viber-message-container">
                <div class="message-bubble">
                  <!-- Image -->
                  <div class="message-image" *ngIf="block.variables?.image_url">
                    <img [src]="$safeNavigationMigration(block.variables?.image_url)" alt="Viber Image"/>
                  </div>

                  <!-- Content Section with text -->
                  <div class="message-content" *ngIf="block.variables?.text">
                    <div class="message-text" [innerHTML]="$safeNavigationMigration(block.variables?.text)"></div>
                  </div>

                  <!-- CTA Button -->
                  <a
                    *ngIf="block.variables?.cta_link && block.variables?.cta_text"
                    class="message-cta"
                    [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.cta_link))"
                    target="_blank"
                  >
                    {{ block.variables?.cta_text }}
                  </a>

                  <div class="message-time">{{ currentTime }}</div>
                </div>
              </div>
            </div>

            <!-- Home Indicator -->
            <div class="home-indicator"></div>
          </div>
        </div>

        <!-- Regular preview (edit mode) -->
        <div *ngIf="!isPreview" class="viber-message">
          <!-- Image -->
          <div class="viber-image" *ngIf="block.variables?.image_url">
            <img [src]="$safeNavigationMigration(block.variables?.image_url)" alt="Viber Image"/>
          </div>

          <!-- Content Section -->
          <div class="viber-content">
            <div class="viber-text" [innerHTML]="$safeNavigationMigration(block.variables?.text)"></div>
          </div>

          <!-- CTA Button -->
          <a
            *ngIf="block.variables?.cta_link && block.variables?.cta_text"
            class="viber-cta-btn"
            [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.cta_link))"
            target="_blank"
          >
            {{ block.variables?.cta_text }}
          </a>
        </div>
      </div>
    </div>

    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
